export default __webpack_public_path__ + "static/media/pop3.19c43347.jpg";